import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toggle-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toggle-button.component.html',
  styleUrl: './toggle-button.component.css'
})
export class ToggleButtonComponent {
  @Input() toggleButton: boolean = false;
  @Output() toggleButtonChange = new EventEmitter<boolean>();

  @Input() isDisabled: boolean = false;

  onToggle(): void {
    if (!this.isDisabled) {
      this.toggleButton = !this.toggleButton;
      this.toggleButtonChange.emit(this.toggleButton);
    }
  }
}
